import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import React from "react";
import { AuthProvider } from "react-oidc-context";
import App from "./App";
import { configurationHelper } from "./configurationHelper";
import { User, WebStorageStateStore } from "oidc-client-ts";

const oidcConfig = {
  authority: configurationHelper.get("OPENID_AUTHORITY") ?? "",
  client_id: configurationHelper.get("OPENID_CLIENT_ID") ?? "",
  redirect_uri: configurationHelper.get("OPENID_REDIRECT_URI") ?? "",
  scope: configurationHelper.get("OPENID_SCOPES") ?? "",
  onSigninCallback: (user: User | void): void => {
    window.history.replaceState({}, document.title, window.location.pathname);
    window.location.href = window.location.href.replace("/response-oidc", "");
  },
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
